import React from 'react';
import { Box, H3, H5, P, Drawer, Button, T } from '@veracity/vui';

const TemplateDrawer = ({ isOpen, onClose, template }) => (
  <Drawer isOpen={isOpen} onClose={onClose} direction="right">
    <Box p={4}
        height="100%"
        maxHeight="100vh"
        overflowY="auto"
        mb={4}
        flexDirection="column"
    >
      <H3 mb={4}>{template?.name || 'Template Details'}</H3>
      <P mb={2}>ID: {template?.id}</P>
      <P mb={4}>Tag: {template?.tag}</P>
      
      {template?.sections?.map((section) => (
        <Box key={section.id} mb={4} p={4} border="1px solid" borderColor="gray.200" borderRadius="md" flexDirection="column">
          <H5 mb={2}>{section.tag}</H5>
          {section.checks?.map((check) => (
            <Box key={check.id} mb={2} color='green' justifyContent="center">
              <P fontWeight="semibold">{check.label}</P>
             
              {check.info && <P ml={4} color="gray.600">{check.info}</P>}
             
            </Box>
            
          ))}
        </Box>
      ))}
    </Box>
    
    <Box display="flex" justifyContent="center" p={2} flexDirection="row" mt={2}>
    <Button onClick={onClose}>Close</Button>
    </Box>
  </Drawer>
);

export default TemplateDrawer;